import { BsModalRef } from 'ngx-bootstrap/modal';
import { Tooltip } from '../../model/content/contentTooltip.model';
import { HelpModalDirective } from '../help-modal.directive';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';

declare let delta: any;

@Component({
  selector: 'ngc-refundable-flights',
  templateUrl: 'refundable-flights.component.html'
})
export class RefundableFlightsComponent implements AfterViewInit {
  @ViewChild('helpDialog') helpDialog: any;
  isModalShown = false;
  helpModalDir: HelpModalDirective;
  tooltipContent: Tooltip;
  modalConfig = {
    animated: false,
    show: true
  };

  constructor(
    public bsModalRef: BsModalRef,
    private elementRef: ElementRef,
    private srv: CommonService
  ) {}

  close() {
    this.bsModalRef.hide();
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.srv.trapFocusInsideModal(this.elementRef);
    }, 500);
  }
}
